import { DirectoryOrganisationUnitColumnType } from './directory-column-type';

export class DirectoryColumn {
   public organisationUnitName: string;
   public organisationUnitNumber: string;
   public organisationUnitColumnKey: string;
   public columnTyp: DirectoryOrganisationUnitColumnType;

   constructor(organisationUnitName: string, organisationUnitNumber: string, organisationUnitColumnKey: string) {
      this.organisationUnitName = organisationUnitName;
      this.organisationUnitNumber = organisationUnitNumber;
      this.organisationUnitColumnKey = organisationUnitColumnKey;

      this.columnTyp = DirectoryOrganisationUnitColumnType.valueByColumnKey(organisationUnitColumnKey);
   }

   public get directoryColumnKey(): string {
      return `tbl_org_${this.organisationUnitNumber}_${this.organisationUnitColumnKey}`;
   }
}
